import { putAllNot } from '@/api/chat'
import { SET_MESSAGE_VALUE_BY_ID } from '@/constants/pub_sub'

export default {
    data () {
        return {
            isRequesting: false
        }
    },
    props: {
        messageId: {
            type: String,
            required: true
        },
        hasClickAllNot: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        async allNot () {
            if (this.isRequesting || this.hasClickAllNot) {
                return
            }
            this.isRequesting = true
            try {
                await putAllNot(
                    this.$eventBus.uid,
                    this.$eventBus.chatSource,
                    this.$eventBus.entryKey,
                    this.idFromServer
                )

                setMessageHasClickAllNot.call(this, this.messageId)
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
            } finally {
                this.isRequesting = false
            }

            function setMessageHasClickAllNot (messageId) {
                this.$eventBus.$emit(SET_MESSAGE_VALUE_BY_ID, {
                    id: messageId,
                    path: 'robot.hasClickAllNot',
                    value: true
                })
            }
        }
    }
}
